exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._7suHs{position:absolute;top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._7suHs ._1L5i7{position:relative;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}", ""]);

// exports
exports.locals = {
	"main-ui-block": "_7suHs",
	"mainUiBlock": "_7suHs",
	"tooltip-container-wrapper": "_1L5i7",
	"tooltipContainerWrapper": "_1L5i7"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--9-1!../node_modules/postcss-loader/lib??ref--9-2!../node_modules/sass-loader/lib/loader.js??ref--9-3!./default-modules/ui/main-ui-block/main-ui-block.scss
// module id = 167
// module chunks = 0 1 2 3 4